import LanguageSelector, { changeLanguage } from "./language-selector";

export default LanguageSelector;
export {
    changeLanguage
}